import useGetPodcastEpisodeDetail from 'api/hooks/useGetPodcastEpisodeDetail';
import Chip from 'components/Chip';
import LockedThumbnail from 'components/LockedThumbnail';
import Spacer from 'components/Spacer';
import { Heading } from 'components/Typography';
import { useModalContents } from 'context/ModalContentsContext';
import { BlockedEpisodeModal, useModalControls } from 'context/ModalContext';
import styles from './BlockedEpisodeContents.module.scss';

interface BlockedEpisodeContentsProps {}

const BlockedEpisodeContents: React.FC<BlockedEpisodeContentsProps> = () => {
  const { params } = useModalContents<BlockedEpisodeModal['params']>();
  const { podcastId, episodeId } = params;
  const { data } = useGetPodcastEpisodeDetail({ episodeId, podcastId });
  const { close } = useModalControls();

  return (
    <Spacer orientation="vertical" align="center" space="30px">
      <Spacer
        align="center"
        className={styles.root}
        orientation="vertical"
        space="16px"
      >
        <LockedThumbnail
          src={data?.thumbnailImageUrl}
          alt="episode artwork"
          size="large"
          ratio={1}
          className={styles.thumbnail}
        />
        <Heading className={styles.headline} align="center" level={1}>
          This episode is private
        </Heading>
        <Heading level={2}>
          We don’t support private feeds yet, but you can listen to it elsewhere
          or discover some other amazing podcasts here:
        </Heading>
      </Spacer>
      <Chip onClick={close}>discover other podcasts</Chip>
    </Spacer>
  );
};
export default BlockedEpisodeContents;
